export enum RealtimeEventType {
  BulkActionCreate = 'BulkActionCreate',
  BulkActionLogCreate = 'BulkActionLogCreate',
  BulkActionUpdate = 'BulkActionUpdate',

  CardArchived = 'CardArchived',
  CardCommentCreate = 'CardCommentCreate',
  CardCommentUpdate = 'CardCommentUpdate',
  CardCreate = 'CardCreate',
  CardFieldAnswered = 'CardFieldAnswered',
  CardLogCreate = 'CardLogCreate',
  CardMove = 'CardMove',
  CardUnarchived = 'CardUnarchived',
  CardUpdate = 'CardUpdate',

  ClientAuth = 'ClientAuth',
  ClientHeartbeat = 'ClientHeartbeat',
  ClientHello = 'ClientHello',
  ClientSubscribe = 'ClientSubscribe',
  ClientUnsubscribe = 'ClientUnsubscribe',

  ExportCreate = 'ExportCreate',
  ExportLogCreate = 'ExportLogCreate',
  ExportUpdate = 'ExportUpdate',

  MySpaceMyCardsCreate = 'MySpaceMyCardsCreate',
  MySpaceMyCardsRefresh = 'MySpaceMyCardsRefresh',
  MySpaceMyCardsUpdate = 'MySpaceMyCardsUpdate',

  MySpaceMyReviewsCreate = 'MySpaceMyReviewsCreate',
  MySpaceMyReviewsRefresh = 'MySpaceMyReviewsRefresh',
  MySpaceMyReviewsUpdate = 'MySpaceMyReviewsUpdate',

  MySpaceMySolicitationsCreate = 'MySpaceMySolicitationsCreate',
  MySpaceMySolicitationsRefresh = 'MySpaceMySolicitationsRefresh',
  MySpaceMySolicitationsUpdate = 'MySpaceMySolicitationsUpdate',

  MySpaceMyTasksCreate = 'MySpaceMyTasksCreate',
  MySpaceMyTasksRefresh = 'MySpaceMyTasksRefresh',
  MySpaceMyTasksUpdate = 'MySpaceMyTasksUpdate',

  NotificationCreate = 'NotificationCreate',

  SystemAcknowledge = 'SystemAck',
  SystemClose = 'SystemClose',
  SystemConnect = 'SystemConnect',
  SystemError = 'SystemError',
  SystemHeartbeat = 'SystemHeartbeat',
  SystemHello = 'SystemHello',
}
